import { getAttributeValue } from '../../../../helpers/getAttributeValue';

const getMountType = getAttributeValue('mountType');

export default {
  check: (sourceItem, targetItem) => getMountType(sourceItem) === getMountType(targetItem),
  errorMessage: (/* sourceItem, targetItem */) => (
    'Incorrect mount type'
  ),
};
